// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCHpI_Z0dZWILm3d1s-TKCWCYTO-aebn-0",
  authDomain: "floring-8f2d4.firebaseapp.com",
  databaseURL: "https://floring-8f2d4.firebaseio.com",
  projectId: "floring-8f2d4",
  storageBucket: "floring-8f2d4.appspot.com",
  messagingSenderId: "381443958872",
  appId: "1:381443958872:web:d7d3115a054ca05bc9422d",
  measurementId: "G-36S0H106SV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const analytics = getAnalytics(app);

export const auth = getAuth(app);

export const db = getFirestore(app);

export default app;
logEvent(analytics, 'page_view', {
  page_path: '/',
});